import React from 'react';
import { FiCheckCircle, FiCircle, FiShield } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const VisibilityScore = () => {
  const checkpoints = [
    { label: "Answer Placement (First 200px)", status: true },
    { label: "Question-Formatted H2s (>30%)", status: true },
    { label: "Factual Density (Specific Numbers)", status: true },
    { label: "JSON-LD Schema Validation", status: true },
    { label: "Speakable Schema Enabled", status: false }
  ];

  return (
    <div className="bg-white p-8 rounded-[2.5rem] border border-slate-200 shadow-2xl">
      <div className="flex items-center gap-3 mb-8">
        <div className="w-10 h-10 bg-orange-100 text-orange-600 rounded-xl flex items-center justify-center">
          <SafeIcon icon={FiShield} />
        </div>
        <div>
          <h4 className="font-bold text-slate-900 leading-none mb-1">Visibility Score Checklist</h4>
          <p className="text-[10px] text-slate-400 uppercase font-black tracking-widest">AEO Audit Protocol 2026</p>
        </div>
      </div>

      <div className="space-y-4 mb-8">
        {checkpoints.map((cp, i) => (
          <div key={i} className="flex items-center justify-between p-3 rounded-xl bg-slate-50 border border-slate-100">
            <span className="text-sm font-bold text-slate-700">{cp.label}</span>
            <SafeIcon 
              icon={cp.status ? FiCheckCircle : FiCircle} 
              className={cp.status ? "text-green-500" : "text-slate-300"} 
            />
          </div>
        ))}
      </div>

      <div className="pt-6 border-t border-slate-100">
        <div className="flex justify-between items-end">
          <div>
            <p className="text-xs font-bold text-slate-400 uppercase mb-1">Current AEO Readiness</p>
            <p className="text-4xl font-black text-slate-900">80<span className="text-orange-500">%</span></p>
          </div>
          <button className="px-4 py-2 bg-slate-900 text-white text-xs font-bold rounded-lg hover:bg-orange-600 transition-colors">
            Run Full Audit
          </button>
        </div>
      </div>
    </div>
  );
};

export default VisibilityScore;